import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

import { formatDate } from 'utils/date';


@Pipe({name: 'formatDate'})
export class FormatDatePipe implements PipeTransform {
  transform(date: string, withYear: boolean = true, now: Date = new Date(), timezone?: any, isSpecial?: boolean): any {
    try {
      moment.utc(date);
    } catch (e) {
      return date;
    }
    if (isSpecial === undefined) { isSpecial = true; }
    return formatDate(date, withYear, now, isSpecial, timezone);
  }
}
